import smoothScroll from 'smoothscroll-polyfill'
import merge from 'lodash/merge'
import each from 'lodash/each'

smoothScroll.polyfill()

const defaults = {
  speed: 1.3
}

const mediaQueries = {
  sm: 'only screen and (max-width: 767px)',
  md: 'only screen and (min-width: 768px) and (max-width: 1280px)',
  lg: 'only screen and (min-width: 1281px)'
}

const scrollDiffs = {
  sm: 67,
  md: 94,
  lg: 70
}

export default class {
  constructor (selector, wrapper = window, options) {
    this._wrapper = wrapper
    this._header = document.getElementById('js-header')
    this._triggers = document.querySelectorAll(selector)
    this._options = merge(defaults, options)
    this._selector = selector
    this._handlers = {}
    this._mediaQueries = {}

    this._handleEvents()
  }

  /**
   * イベントの設定
   */
  _handleEvents () {
    each(this._triggers, (el) => {
      el.addEventListener('click', this._clickHandler.bind(this))
    })

    each(mediaQueries, (mediaQuery, key) => {
      this._mediaQueries[key] = window.matchMedia(mediaQuery)
    })
  }

  _getCurrentMedia () {
    let currentMode = ''

    each(this._mediaQueries, (mediaQuery, key) => {
      if (mediaQuery.matches) {
        currentMode = key
        return false
      }
    })

    return currentMode
  }

  /**
   * クリックハンドラ
   * クリックされた要素に設定されているセレクタの位置を算出し、
   * アニメーションで移動させる
   * @param  {Obj} e Event
   */
  _clickHandler (e) {
    const trigger = e.currentTarget
    const id = trigger.getAttribute('data-target') || trigger.getAttribute('href')
    const target = document.querySelector(id)
    const mode = this._getCurrentMedia()
    const offsetTarget = (target) ? target.offsetTop - scrollDiffs[mode] : 0
    const offsetCalc = (offsetTarget > 0) ? offsetTarget : 0

    window.scroll({ top: offsetCalc, left: 0, behavior: 'smooth' })

    e.preventDefault()
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/Scroller.js